import React, { Component } from 'react';

// import Tabs from '../../components/Tab';
import Assets from './Assets';
// import Deposits from './Deposits';
// import Fees from './Fees';
import { Wrapper } from './style';
import { getTabParams } from '../../common/utils'
// import Transfers from './Transfers';
// import MoveToKit from '../MoveToKit';

class Financial extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tabParams: getTabParams(),
            hideTabs: false
        }
    }

    handleHide = (value) => {
        this.setState({ hideTabs: value });
    };

    renderTabBar = (props, DefaultTabBar) => {
        if (this.state.hideTabs) return <div></div>;
        return (
            <DefaultTabBar {...props} />
        );
    };

    render() {
        // const { tabParams } = this.state;
        // const FinancialTabList = [
        //     {
        //         key: 'assets',
        //         name: 'Assets',
        //         content: (
        //             <Assets
        //                 location={this.props.location}
        //                 handleHide={this.handleHide}
        //             />
        //         )
        //     },
        //     {
        //         key: 'deposits',
        //         name: 'Deposits',
        //         content: <Deposits type="deposit" />
        //         // content: <MoveToKit />
        //     },
        //     {
        //         key: 'withdrawals',
        //         name: 'Withdrawals',
        //         content: <Deposits type="withdrawals" />
        //         // content: <MoveToKit />
        //     },
        //     {
        //         key: 'earnings',
        //         name: 'Earnings',
        //         content: <Fees />
        //     },
        //     {
        //         key: 'transfers',
        //         name: 'Transfers',
        //         content: <Transfers />
        //     }
        // ];
        return (
            <Wrapper>
                <div className="main-header">
                    Assets
				</div>
                {/* <Tabs
                    TabList={FinancialTabList}
                    activeTab={tabParams.tab}
                    renderTabBar={this.renderTabBar}
                /> */}
                <Assets
                    location={this.props.location}
                    handleHide={this.handleHide}
                />
            </Wrapper>
        );
    }
}

export default Financial;